<template>
  <div v-bsl="displaySidebar" class="fixed w-screen z-50">
    <!-- Sidebar -->
    <transition
      enter-active-class="transition-opacity duration-100 ease-linear"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-300 ease-linear"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
      @enter="displaySidebarContent = true"
    >
      <div v-if="displaySidebar" class="fixed inset-0 z-40 flex justify-end">
        <div class="fixed w-screen h-screen">
          <div
            class="absolute inset-0 bg-gray-600 opacity-75"
            @click="handleCloseSidebar"
          />
        </div>
        <transition
          enter-active-class="transition duration-300 ease-in-out transform"
          enter-class="translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition duration-300 ease-in-out transform"
          leave-class="translate-x-0"
          leave-to-class="translate-x-full"
        >
          <div
            v-show="displaySidebarContent"
            class="relative flex flex-col flex-1 bg-white sm:max-w-xs"
          >
            <div class="absolute top-0 right-0 p-1">
              <button
                class="
                  flex
                  items-center
                  justify-center
                  w-12
                  h-12
                  rounded-full
                  focus:outline-none
                  tmsk-blue-text
                "
                aria-label="Close sidebar"
                id="close-sidebar"
                @click="handleCloseSidebar"
              >
                <svg
                  class="w-6 h-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="flex-1 h-0 pt-16 pb-4 overflow-y-auto">
              <div class="flex items-center justify-center flex-shrink-0 px-4">
                <img
                  class="w-auto h-6"
                  src="@/assets/img/staymasked-logo.svg"
                  alt="Workflow"
                />
              </div>
              <nav class="my-5">
                <a
                  class="sidebar-link focus:outline-none"
                  @click="handleNavigation('Home')"
                >
                  Home
                </a>
                <a
                  v-if="isLoggedIn"
                  class="sidebar-link focus:outline-none"
                  @click="handleNavigation('MyOrders')"
                >
                  My Orders
                </a>
                <a
                  class="sidebar-link focus:outline-none"
                  @click="
                    handleNavigation(
                      'URL',
                      'http://stayprepared.sg/sizing-guide'
                    )
                  "
                >
                  Mask Sizing Guide
                </a>
                <a
                  class="sidebar-link focus:outline-none"
                  @click="handleNavigation('CollectFreeMasks')"
                >
                  Collect Free Masks
                </a>
                <a
                  v-if="isPreOrderActive"
                  class="sidebar-link focus:outline-none"
                  @click="handleNavigation('Purchase')"
                >
                  Pre-order Additional Masks
                </a>
                <a
                  class="sidebar-link focus:outline-none"
                  @click="handleNavigation('LocateVendingMachines')"
                >
                  Locate Vending Machines
                </a>
                <a
                  class="sidebar-link focus:outline-none"
                  @click="
                    handleNavigation(
                      'URL',
                      'https://stayprepared.sg/staymasked/'
                    )
                  "
                >
                  About StayMasked
                </a>
                <a
                  class="sidebar-link focus:outline-none"
                  @click="
                    handleNavigation('URL', 'https://stayprepared.sg/masks-faq')
                  "
                >
                  FAQ
                </a>
              </nav>

              <a
                v-if="isLoggedIn && !isPayLahTile"
                data-e2e-attr="nav-bar-logout-btn"
                class="mt-6 sidebar-link focus:outline-none"
                @click="handleNavigation('Logout')"
              >
                Logout
              </a>
              <a
                v-if="!isLoggedIn && !isPayLahTile"
                data-e2e-attr="nav-bar-login-btn"
                class="mt-6 sidebar-link focus:outline-none"
                @click="handleNavigation('Login')"
              >
                Login
              </a>
              <!-- <a
                v-if="isLoggedIn && isPayLahTile"
                class="mt-6 sidebar-link focus:outline-none"
                @click="handleNavigation('Login')"
              >
                Switch Mobile
              </a> -->
            </div>
            <div class="flex flex-shrink-0 px-4 pb-8 space-x-4">
              <div class="flex items-center justify-center flex-1">
                <img
                  class="inline-block w-32"
                  src="@/assets/img/stay-prepared-logo.svg"
                />
              </div>
              <div class="flex items-center justify-center flex-1">
                <img
                  class="inline-block w-28"
                  src="@/assets/img/temasek-foundation-logo.svg"
                />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
    <!-- Top NavBar -->
    <div data-e2e-attr="header-container" class="space-x-4 top-navbar sm:px-12">
      <img
        v-if="!['Maintenance', 'Prelaunch'].includes($route.name)"
        id="img_id"
        class="h-4 cursor-pointer sm:h-6"
        src="https://cdn1.stayprepared.sg/wp-content/uploads/sites/12/2020/05/staymasked-logo-v3.svg.gzip"
        @click="handleNavigation('Home')"
      />
      <img
        v-else
        id="img_id"
        class="h-4 sm:h-6"
        src="https://cdn1.stayprepared.sg/wp-content/uploads/sites/12/2020/05/staymasked-logo-v3.svg.gzip"
      />
      <div
        v-if="!['Maintenance', 'Prelaunch'].includes($route.name)"
        class="
          flex flex-row
          items-center
          justify-end
          flex-1
          space-x-4
          print:hidden
        "
      >
        <button
          v-if="isLoggedIn"
          class="hidden sm:block focus:outline-none"
          @click="handleNavigation('MyOrders')"
        >
          <span class="text-sm tmsk-blue-text"> My Orders </span>
        </button>
        <button
          v-if="isLoggedIn && !isPayLahTile"
          class="focus:outline-none"
          data-e2e-attr="header-logout-btn"
          @click="handleNavigation('Logout')"
        >
          <span class="text-sm tmsk-blue-text"> Logout </span>
        </button>
        <!-- <button
          v-if="isLoggedIn && isPayLahTile"
          class="focus:outline-none"
          @click="handleNavigation('Login')"
        >
          <span class="text-sm tmsk-blue-text">
            Switch Mobile
          </span>
        </button> -->
        <button
          id="loginBtn"
          data-e2e-attr="header-login-btn"
          v-if="!isLoggedIn"
          @click="handleNavigation('Login')"
        >
          <span class="text-sm tmsk-blue-text">Login</span>
        </button>
        <button
          data-e2e-attr="menu-btn"
          class="focus:outline-none"
          @click="displaySidebar = true"
        >
          <svg
            class="w-5 h-5 cursor-pointer tmsk-blue-text"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState } from 'vuex'
export default {
  name: 'NavBar',
  mixins: [],
  props: {},
  data() {
    return {
      displaySidebar: false,
      displaySidebarContent: false,
    }
  },
  computed: {
    ...mapGetters(['isPreOrderActive']),
    ...mapState(['isLoggedIn', 'isPayLahTile']),
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handleNavigation(name, url) {
      if (name === 'URL') {
        window.open(url, '_blank')
      } else if (this.$route.name !== name) {
        this.$router.push({ name: name, query: this.$route.query })
      }

      this.handleCloseSidebar()
    },

    handleCloseSidebar() {
      this.displaySidebar = false
      this.displaySidebarContent = false
    },

    handleLogout() {
      this.$router.push({ name: 'Logout', query: this.$route.query })
    },
  },
}
</script>

<style scoped></style>
